const auth = {
  // 未充值用户权益介绍查询
  queryNonSvipUserPosition: `/authApi/svip/v1/queryNonSvipUserPosition`,
  // SVIP用户信息查询
  querySvipUserInfo: `/authApi/svip/v1/querySvipUserInfo`,
  // SVIP等级配置说明查询
  querySvipRightDescription: `/authApi/svip/v1/querySvipRightDescription`,
  // 权益配置查询
  querySvipRights: `/authApi/svip/v1/querySvipRights`,
  // 用户等级特权查询
  querySvipUserLevelRights: `/authApi/svip/v1/querySvipUserLevelRights`,
  // 用户等级特权查询接口_V2
  querySvipUserLevelRightsVtwo: `/authApi/svip/v2/querySvipUserLevelRights`,
  // SVIP游戏礼包和属性称号查询接口
  querySvipGameRightWithGame: `/authApi/svip/v2/querySvipGameRightWithGame`,
  // 用户领取积分总数查询
  querySvipUserTotalCent: `/authApi/svip/v1/querySvipUserTotalCent`,
  // 用户云手机权益信息查询
  querySvipUserCloudTelInfo: `/authApi/svip/v1/querySvipUserCloudTelInfo`,
  // 用户权益值可领取情况查询
  querySvipUserRightValue: `/authApi/svip/v1/querySvipUserRightValue`,
  // 用户云手机权益领取接口
  useSvipUserRights: `/authApi/svip/v1/useSvipUserRights`,
  // 用户每月领取积分总数查询
  querySvipUserCentRecord: `/authApi/svip/v1/querySvipUserCentRecord`,
  // 获取优惠券列表
  getList: `/userApi/v3/Coupon/getList`,
  // 查询当前用户信息
  memberInfo: `/userApi/v3/User/info`,
  // SVIP用户未领取权益查询
  querySvipUserAvailableRights: `/authApi/svip/v1/querySvipUserAvailableRights`,
  // SVIP游戏礼包领取重置说明查询接口
  querySvipGameGiftResetInfo: `/authApi/svip/v1/querySvipGameGiftResetInfo`,
  // 成长值说明---范昂
  queryGrowthValueDesc: `/authApi/svip/v1/queryGrowthValueDesc`,
  // 用户成长值按月汇总记录---范昂
  queryGrowthValueMonthLog: `/authApi/svip/v1/queryGrowthValueMonthLog`,
  // 用户成长值明细记录---范昂
  queryGrowthValueDetailLog: `/authApi/svip/v1/queryGrowthValueDetailLog`,
  // 查询成长值明细下拉列表配置---范昂
  queryGrowthValueDropDownConf: `/authApi/svip/v1/queryGrowthValueDropDownConf`,
  // 成长值扣除规则配置---范昂
  queryGrowthValueReduceRuleConf: `/authApi/svip/v1/queryGrowthValueReduceRuleConf`,
  // 成长值增加规则配置---范昂
  queryGrowthValueAddRuleConf: `/authApi/svip/v1/queryGrowthValueAddRuleConf`,
  // 用户成长值预扣除情况查询---范昂
  queryPreReduceGrowthValue: `/authApi/svip/v1/queryPreReduceGrowthValue`
};

export default auth;
